import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

import { ReactComponent as Icon } from './SearchIcon.svg';

/**
 * @function
 * Auto-generated file.
 */
export const SearchIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(function SearchIcon(props, ref) {
  return (
    <SvgIcon ref={ref} viewBox="0 0 16 16" component={Icon} {...props} />
  );
});
